<div class="root">
  <input class="input" type="text" [placeholder]="placeholderText" [(ngModel)]="text" (input)="onChange()"
    [appAutofocus]="autofocus">

  <div class="icon" [class.is-loading]="isLoading">
    <ng-container *ngIf="isLoading">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </ng-container>

    <ng-container *ngIf="!isLoading">
      <app-lucide-icon [iconName]="'search'" [size]="26"></app-lucide-icon>
    </ng-container>
  </div>
</div>